import React from 'react';
import Timeline from './Timeline'; // Import the reusable Timeline component

const studiesData = [
  {
    title: "M.Sc. Computer Science",
    subtitle: "University of Hamburg",
    duration: "2021 - 2023",
    details: [
      "Grade: 1.61",
      "Thesis: Unsupervised Learning for Out-of-Distribution Generalization on a Multimodal Sequence Dataset",
      "Key Focuses: Artificial Intelligence, Machine Learning, Computer Vision, Software Engineering"
    ]
  },
  {
    title: "B.Sc. Computer Science",
    subtitle: "University of Hamburg",
    duration: "2017 - 2020",
    details: [
      "Grade: 2.32",
      "Thesis: Towards Real-time Indoor Collision Avoidance Through Monocular Depth Estimation",
      "Key Focuses: Artificial Intelligence, Machine Learning, Software Engineering"
    ]
  },
  {
    title: "B.Sc. Physics ",
    subtitle: "University of Hamburg",
    duration: "2014 - 2017",
    details: ["(Unfinished) Switched to Computer Science"]
  },
  {
    title: "Abitur",
    subtitle: "Gymnasium Dörpsweg",
    duration: "2006 - 2014",
    details: ["Grade: 2.3"]
  }
];

const Studies = ({ id }) => {
  return (
    <Timeline
      id={id}
      items={studiesData}
      title="Education"
      position="right" // Set timeline position to the right
    />
  );
};

export default Studies;
